
import EditModule from "@/components/ModuleEdit.vue";
import { Module } from "@/models/module";
import {ModuleService} from "@/services/module-service";
import Vue from "vue";
export default Vue.extend({
	data() {
		return {
			module: new Module()
		};
	},
	methods: {
		async save() {
			await ModuleService.createModule(this.module);
			this.$router.push("/modules");
		}
	},
	components: {
		EditModule
	}
});
